import { FARM_NAME, LOCATION } from "@/lib/contact";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#E8DFC8] bg-[#FAF7F2] px-5 py-8">
    <div className="mx-auto flex max-w-6xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <p className="font-display text-sm font-semibold text-[#2A1810]">{FARM_NAME}</p>
      <p className="font-mono-brand text-[11px] uppercase tracking-[0.18em] text-[#8C7A70]">{LOCATION}</p>
      <p data-testid="footer-copyright" className="text-xs text-[#8C7A70]">
        © {new Date().getFullYear()} {FARM_NAME} · ksrpoultryfarms.com
      </p>
    </div>
  </footer>
);

export default Footer;
